import {AsyncCoursePrice} from '@udemy-v2/react-course-pricing';
import {DiscountAttempt} from '@udemy-v2/api-shopping';
import {
    DISCOUNT_STATUSES,
    SOURCE_TYPE,
} from '@/features/course-landing-page/components/redeem-coupon/constants';

/**
 * Transforms the return value from useCoursePrice to a DiscountAttempt object
 *
 * @param coursePrice - The course price data from useCoursePrice hook
 * @returns DiscountAttempt object or null if no discount is available
 */
export function transformCoursePriceToDiscount(
    coursePrice?: AsyncCoursePrice,
): DiscountAttempt | null {
    // Return null if no course price data or no discount information
    if (!coursePrice?.code) {
        return null;
    }

    // Determine source type based on campaign data
    // If no campaign data or campaign is instructor-created, treat as instructor coupon
    // Otherwise treat as Udemy coupon
    const isInstructorCoupon = coursePrice.campaign?.isInstructorCreated ?? true;
    const sourceType = isInstructorCoupon
        ? SOURCE_TYPE.INSTRUCTOR_COUPON
        : SOURCE_TYPE.UDEMY_COUPON;

    // Create details string with campaign information if available
    let details: string | undefined;
    if (coursePrice.campaign) {
        const campaign = coursePrice.campaign;
        const expiryInfo = campaign.endTime
            ? `Expires: ${new Date(campaign.endTime).toLocaleDateString()}`
            : 'No expiry';
        const usageInfo =
            campaign.usesRemaining !== null && campaign.maximumUses !== null
                ? `Uses remaining: ${campaign.usesRemaining}/${campaign.maximumUses}`
                : '';
        details = [expiryInfo, usageInfo].filter(Boolean).join(' | ');
    }

    return {
        code: coursePrice.code,
        details,
        status: DISCOUNT_STATUSES.APPLIED,
        source_type: sourceType,
    };
}
